import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Typography, CircularProgress, Alert, IconButton, Tabs, Tab } from '@mui/material';
import { Delete } from '@mui/icons-material';
import { newsService } from '../../firebase/services';
import MinorInfoBox from '../components/MinorInfoBox';
import AdSpace from '../components/AdSpace';

export default function NewsList() {
  const [news, setNews] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [adminUid, setAdminUid] = useState(null);
  const [tab, setTab] = useState(0);
  const navigate = useNavigate();

  const loadNews = async () => {
    try {
      setLoading(true);
      setError(null);
      const newsData = await newsService.getAllNews();
      const sortedNews = [...newsData].sort((a, b) => (b.createdAt || 0) - (a.createdAt || 0));
      setNews(sortedNews);
    } catch (error) {
      console.error('Erro ao carregar notícias:', error);
      setError('Falha ao carregar as notícias. Por favor, tente novamente.');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadNews();
    setAdminUid(localStorage.getItem('admin_uid'));
    const handleNewsUpdated = () => {
      loadNews();
    };
    window.addEventListener('newsUpdated', handleNewsUpdated);
    return () => {
      window.removeEventListener('newsUpdated', handleNewsUpdated);
    };
  }, []);

  const deleteNews = async (newsId) => {
    try {
      await newsService.deleteNews(newsId);
      setNews(news.filter(item => item.id !== newsId));
    } catch (error) {
      console.error('Erro ao deletar notícia:', error);
      setError('Falha ao deletar a notícia. Por favor, tente novamente.');
    }
  };

  const highlightedNews = news.filter(n => n.isHighlighted);
  const displayedNews = tab === 0 ? news : highlightedNews;

  return (
    <Box 
      sx={{
        width: '100%',
        margin: '0',
        padding: { xs: 2, sm: 3 },
        minHeight: '80vh',
        boxSizing: 'border-box'
      }}
    >
      <Typography 
        variant="h4" 
        sx={{
          fontFamily: 'Atlan',
          fontWeight: 'bold',
          marginBottom: 3,
          textAlign: 'center',
          color: '#0b2951'
        }}
      >
        Notícias
      </Typography>

      {/* Espaço publicitário */}
      <AdSpace 
        height="100px"
        sx={{ 
          marginBottom: 3
        }}
      />

      <Tabs value={tab} onChange={(_, v) => setTab(v)}  sx={{ marginBottom:5, marginLeft:{xm: 0, sm: 5}, borderRadius:2}}>
        <Tab label="Recentes"/>
        <Tab label="Destaques" />
      </Tabs>

      {error ? (
        <Alert 
          severity="error" 
          sx={{ marginBottom: 3 }}
          onClose={() => setError(null)}
        >
          {error}
        </Alert>
      ) : loading ? (
        <Box sx={{ display: 'flex', justifyContent: 'center', my: 5 }}>
          <CircularProgress size={60} />
        </Box>
      ) : displayedNews.length === 0 ? (
        <Box 
          sx={{
            textAlign: 'center',
            marginTop: 8
          }}
        >
          <Typography 
            variant="h6" 
            sx={{
              fontFamily: 'Atlan',
              color: '#666',
              marginBottom: 2
            }}
          >
            Nenhuma notícia encontrada
          </Typography>
          <Typography 
            variant="body1" 
            sx={{
              fontFamily: 'Atlan',
              color: '#888'
            }}
          >
            {tab === 0 ? 'Adicione sua primeira notícia para começar!' : 'Nenhuma notícia em destaque.'}
          </Typography>
        </Box>
      ) : (
        <Box sx={{ 
          width: '100%', 
          display: 'flex', 
          flexWrap: 'wrap', 
          gap: 2,
          justifyContent: 'center'
        }}>
          {displayedNews.map((newsItem) => (
            <Box 
              key={newsItem.id} 
              sx={{ 
                position: 'relative', 
                bgcolor: 'white', 
                padding: 1, 
                borderRadius: 2, 
                boxShadow: 5,
                width: { xs: '280px', sm: '340px' },
                flexGrow: 0,
                flexShrink: 0
              }}
            >
              <MinorInfoBox
                title={newsItem.title}
                subtitle={newsItem.subtitle}
                mediaUrl={newsItem.mediaUrl}
                driveFileId={newsItem.driveFileId}
                thumbnailUrl={newsItem.thumbnailUrl}
                marginBottom={0}
                disableResponsiveness={true}
                
                isClickable={true}
                onClick={() => navigate(`/article/${newsItem.id}`)}
              />
              {adminUid && (
                <IconButton
                  size="small"
                  onClick={(e) => {
                    e.stopPropagation();
                    deleteNews(newsItem.id);
                  }}
                  sx={{
                    position: 'absolute',
                    top: 4,
                    right: 4,
                    zIndex: 2
                  }}
                >
                  <Delete color="error" fontSize="small" />
                </IconButton>
              )}
            </Box>
          ))}
        </Box>
      )}
    </Box>
  );
}
